module.exports = __webpack_public_path__ + "static/img/MuseumAffairs05@2x.06271c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MuseumAffairs05@2x.png
// module id = lKdH
// module chunks = 1